import { 
	SET_CONTRACT_PROPS,
	SET_CONTRACT_PROP_LIST_VALUES,
	SET_CONTRACT_PROP_VALUE_SELECTED
} from "./actions/KPI/actions";

const initialState = {
	_contractProps: null,
	_contractPropListValues: null,
	_contractPropValueIdSelected: null
};
const maintainerReducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_CONTRACT_PROPS:
			return {
				...state,
				_contractProps: action.payload
			};
		case SET_CONTRACT_PROP_LIST_VALUES:
			return {
				...state,
				_contractPropListValues: action.payload
			};	

		case SET_CONTRACT_PROP_VALUE_SELECTED:
			return {
				...state,
				_contractPropValueIdSelected: action.payload
			};	
		default:
			return state;
	}
};
export default maintainerReducer;